/**
 * 对外事件
 */
import emitter from '../../utils/emitter'
import api from './api'
import response from '../../utils/response'
import { cloneDeep, isUndefined } from 'lodash'

export default {
  mixins: [emitter],
  data () {
    return {
      refMap: {}
    }
  },
  methods: {
    getFieldList (key) {
      let result = []
      const fieldList = cloneDeep(this.fieldMap[key] || {})
      Object.values(fieldList).forEach(field => {
        if (field.__isUse) {
          result.push(field)
        }
      })
      return result
    },
    // 获取字段列表
    getFieldMap (objectApiName) {
      if (!objectApiName) {
        let result = {}
        for (let key in this.fieldMap) {
          result[key] = this.getFieldList(key)
        }
        return result
      }
      return this.getFieldList(objectApiName)
    },
    getSelection ({objectApiName} = {}) {
      if (!objectApiName || this.isMain(objectApiName)) {
        this.tableRef = this.childVm('table-render')
        return this.tableRef ? this.tableRef.tableSelection : []
      }
      const curRef = this._getRef('masterRelation', objectApiName)
      if (curRef) {
        return curRef.getSelection('tableSelection')
      }
    },
    // 切换从对象复选框选中状态
    toggleSelection (objectApiName, row, flag) {
      let curRef = null
      if (isUndefined(objectApiName) || this.isMain(objectApiName)) { 
        curRef = this._getRef('table')
      } else {
        curRef = this._getRef('masterRelation', objectApiName)
      }
      if (curRef) {
        curRef.toggleSelection(row, flag)
      }
    },
    // 切换从对象复选框选中状态
    toggleRowExpansion (objectApiName, row, flag) {
      let curRef = null
      if (isUndefined(objectApiName) || this.isMain(objectApiName)) { 
        curRef = this._getRef('table')
      } else {
        curRef = this._getRef('masterRelation', objectApiName)
      }
      if (curRef) {
        curRef.toggleRowExpansion(row, flag)
      }
    },
    // 校验
    validateField (apiName) {
      this._validateField(apiName)
    },

    // 清空校验
    clearValidateField (apiName) {
      this._clearValidateField(apiName)
    },
    
    // 添加行
    addLine ({ objectApiName }, rows, cb) {
      this._handleAddRow(objectApiName, rows, cb)
    },

    // 删除行
    removeLine ({objectApiName}, row) {
      this._handleRemoveRow(objectApiName, row)
    },

    // 添加列
    addColumn (objectApiName, position, items) {
      const curRef = this._getRef('masterRelation', objectApiName)
      if (curRef) {
        return curRef.handleAddColumn(position, items)
      }
    },

    // 删除列
    delColumn (objectApiName, columnId) {
      const curRef = this._getRef('masterRelation', objectApiName)
      if (curRef) {
        return curRef.handleDelColumn(columnId)
      }
    },

    // 查询当前字段状态
    checkElementStatus ({type, objectApiName, fieldApiName}) {
      const elementTypeMap = {
        'field': () => {
          const pageShow = this.fieldMap?.[objectApiName]?.[fieldApiName]?.props?.pageShow
          if (typeof pageShow !== 'boolean') {
            console.log(`无效的字段apiName: 对象:${objectApiName}, 字段:${fieldApiName}`)
          }
          return pageShow
        },
        'column': () => {
          const columnShow = this.columnMap?.[objectApiName]?.[fieldApiName]?.columnShow
          if (typeof columnShow !== 'boolean') {
            console.log(`无效的列apiName: 对象:${objectApiName}, 字段:${fieldApiName}`)
          }
          return columnShow
        }
      }
      const checkHandle = elementTypeMap[type]

      if (!checkHandle) {
        console.log(`无效的type: ${type}`)
      }

      return checkHandle()
    },

    // 更新值
    updateData (data) {
      // 首次渲染
      if (!this.readyState.isData) {
        this.readyState.isData = true
        this.$set(this, 'formData', data)
        return 
      }
      this._updateData(data)
    },
    // 订单-从对象添加初始化新建行
    updateAddRow (data, rowKey = 'aPaaS_SequenceId') {
      for (let k in data) {
        let serialNumber = 0
        data[k].forEach(row => {
          row[rowKey] = `${k}_CREATE_${++serialNumber}`
        })
      }
      this.defaultCreatedRow = data
    },

    updateTableDataRelation (objectApiName, rows) {
      const curRef = this._getRef('masterRelation', objectApiName)
      const data = curRef.subData
      data.splice(0, data.length)
      rows.forEach((item, index) => {
        this.$set(data, index, item)
      })
    },

    // 获取下拉项
    async getChoiceList (objectApiName, apiNames) {
      const {url, type} = api.getChoiceFieldList
      const apiNameList = []
      const choiceMap = {}

      apiNames.forEach(v => {
        const field = this.fieldMap[objectApiName]?.[v]
        if (!field) {
          return apiNameList.push(v)
        }
        choiceMap[v] = field.choiceValues
      })

      if (apiNameList.length > 0) {
        const {isOk, content} = await response({
          method: type,
          url,
          params: {
            objectApiName,
            apiNameList
          }
        })

        if (isOk) {
          content.forEach(v => {
            choiceMap[v.apiName] = v.choiceValues
          })
        }
      }

      return choiceMap
    },
    // 获取弹窗页面
    getPopupRef () {
      const windowRef = this.childVm('popup-window')
      if (windowRef) {
        return windowRef.paasPage
      }
    },
    closePopup () {
      const windowRef = this.childVm('popup-window')
      windowRef && windowRef.onClose()
    }
  }
}
